module.exports = __webpack_public_path__ + "img/dna.1c66533e.gif";